module.exports = __webpack_public_path__ + "static/media/cover.2ae88d71.jpg";